import React, { useState, useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const BPCD = () => {
   
    const [expandida, setExpandida] = useState(null);
    
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
      const toggleImagen = (id) => {
        setExpandida(expandida === id ? null : id);
      };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3 
            className='title'
            style={{ 
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Convocatoria
          </h3>
          
          <div className="hero">

            <h5>Resumen</h5>
            <p></p>
            <div className="contenedor">
              <img
                src="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BPD.jpeg"
                alt="POL-01"
                className={expandida === 1 ? "img expandida" : "img"}
                onClick={() => toggleImagen(1)}
              />
            </div>
          </div>

          <div className="hero">
            <h4>¿Qué debes hacer para registrarte?</h4><p></p><p></p>
            <h6>1.- Lee con atención la convocatoria</h6>
           
            {/* Contenedor para botones */}
            <div className="botones">
              <a 
                href="/documento/29" 
                className="btn-vino"
              >
                Haz clic aquí
              </a>
            </div>
          </div>

            <br />

          <div className="hero">
            <h6>2.- Consulta dónde tramitar los certificados de discapacidad</h6>
            {
            /* Contenedor para botones */}
            <div className="botones">
              <a 
                href="https://sebiso.hidalgo.gob.mx/DGSC" 
                className="btn-vino"
              >
                Haz clic aquí
              </a>
            </div>
          </div>

            <br />

          <div className="hero">
            <h6>3.- Ubica las sedes de registro</h6>
            {/* Contenedor para botones */}
            <div className="botones">
              <a 
                href="https://sebiso.hidalgo.gob.mx/DGSP" 
                className="btn-vino"
              >
                Haz clic aquí
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default BPCD;